(() => {
  "use strict";

  if (customElements.get("product-notification")) return;

  customElements.define(
    "product-notification",
    class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector("[data-notification-form]");
        if (!this.form || this.submitHandler) return;

        this.submitHandler = (event) => this.submitNotification(event);
        this.form.addEventListener("submit", this.submitHandler);
      }

      disconnectedCallback() {
        if (this.form && this.submitHandler) {
          this.form.removeEventListener("submit", this.submitHandler);
          this.submitHandler = null;
        }
      }

      async submitNotification(event) {
        event.preventDefault();
        if (this.sending || !this.form.reportValidity()) return;

        const email = this.form
          .querySelector('input[name="contact[email]"]')
          .value.trim();

        const variantId =
          this.form.dataset.variantId ||
          this.dataset.defaultVariantId;

        if (!/^\d+$/.test(String(variantId))) {
          this.showMessage(
            "Please refresh this page and try again.",
            true
          );
          return;
        }

        this.sending = true;
        const button = this.form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
        this.showMessage("Saving your request…");

        try {
          const response = await fetch(
            "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=SLLTxL",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                revision: "2024-06-15"
              },
              body: JSON.stringify({
                data: {
                  type: "back-in-stock-subscription",
                  attributes: {
                    profile: {
                      data: {
                        type: "profile",
                        attributes: { email }
                      }
                    },
                    channels: ["EMAIL"]
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: "catalog-variant",
                        id: `$shopify:::$default:::${variantId}`
                      }
                    }
                  }
                }
              })
            }
          );

          if (!response.ok) throw new Error("Subscription failed");

          this.showMessage(
            "You're on the list! We'll email you when this item is back in stock."
          );
          this.form.querySelector(
            ".product__notification__form"
          ).hidden = true;
        } catch (error) {
          this.showMessage(
            "We couldn't save your request. Please try again.",
            true
          );
        } finally {
          this.sending = false;
          if (button) button.disabled = false;
        }
      }

      showMessage(text, isError = false) {
        let message = this.form.querySelector(
          "[data-restock-message]"
        );

        if (!message) {
          message = document.createElement("p");
          message.dataset.restockMessage = "";
          message.className = "restock-message";
          message.setAttribute("aria-live", "polite");
          this.form.prepend(message);
        }

        message.setAttribute("role", isError ? "alert" : "status");
        message.textContent = text;
      }
    }
  );
})();